// extracted by mini-css-extract-plugin
module.exports = {"title":"Publish_style_title__1EVEN","imageWrap":"Publish_style_imageWrap__3u0qe"};